import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { ISiteUser } from '../types/ISiteUser';

export interface IGetSiteUsersParams extends IGetItemsParams {
}

export interface IGetSiteUsersResult extends IGetItemsResult {
  users: ISiteUser[];
}

export class GetSiteUsersRequest extends Request<IGetSiteUsersParams, IGetSiteUsersResult> {
  constructor(params: IGetSiteUsersParams) {
    super('getSiteUsers', params);
  }
}
